import LoadingIndicator from '@/widgets/LoadingIndicator'
import NoResultsIndicator from '@/widgets/NoResultsIndicator'
import { getFilterIndicator, getSortIndicator } from '@/lib/tableHelpers'
import KampanieTableRow from './KampanieTableRow'

export default function KampanieTable({
	data,
	loading,
	sortColumn,
	sortDirection,
	onSort,
	onEdit,
	onDelete,
	hasCreatedByFilter,
	onOpenCreatedByFilter,
}) {
	const rows = Array.isArray(data) ? data : []

	if (loading) return <LoadingIndicator />

	return (
		<div className="mt-6 overflow-x-auto">
			<table className="min-w-full bg-white border border-gray-300 rounded-lg shadow">
				<thead>
					<tr>
						<th className="py-2 px-4 border-b border-gray-300 text-left">
							<button
								type="button"
								className="flex items-center gap-1 font-semibold text-gray-700 hover:text-blue-600 transition-colors duration-200 focus:outline-none focus:text-blue-600"
								onClick={() => onSort('nazwa')}>
								Nazwa
								{getSortIndicator('nazwa', sortColumn, sortDirection)}
							</button>
						</th>
						<th className="py-2 px-4 border-b border-gray-300 text-left">
							<button
								type="button"
								className="flex items-center gap-1 font-semibold text-gray-700 hover:text-blue-600 transition-colors duration-200 focus:outline-none focus:text-blue-600"
								onClick={() => onSort('created')}>
								Data utworzenia
								{getSortIndicator('created', sortColumn, sortDirection)}
							</button>
						</th>
						<th className="py-2 px-4 border-b border-gray-300 text-left">
							<div className="inline-flex items-center gap-1">
								<button
									type="button"
									className="flex items-center gap-1 font-semibold text-gray-700 hover:text-blue-600 transition-colors duration-200 focus:outline-none focus:text-blue-600"
									onClick={() => onSort('createdByName')}>
									Utworzyl
									{getSortIndicator('createdByName', sortColumn, sortDirection)}
								</button>
								<button
									type="button"
									className="ml-2 p-1 hover:bg-gray-100 rounded transition-colors duration-200 focus:outline-none focus:bg-gray-100"
									onClick={onOpenCreatedByFilter}
									title="Filtruj kolumne">
									{getFilterIndicator(hasCreatedByFilter)}
								</button>
							</div>
						</th>
						<th className="py-2 px-4 border-b border-gray-300 text-left font-semibold text-gray-700">
							Postep
						</th>
						<th className="py-2 px-4 border-b border-gray-300 text-right font-semibold text-gray-700">
							Akcje
						</th>
					</tr>
				</thead>
				<tbody>
					{rows.map(item => (
						<KampanieTableRow
							key={item._id || item.id || item.nazwa}
							kampania={item}
							onEdit={onEdit}
							onDelete={onDelete}
						/>
					))}
				</tbody>
			</table>
			{rows.length === 0 ? (
				<div className="py-4">
					<NoResultsIndicator
						message="Nie znaleziono kampanii"
						description="Sprobuj zmienic wyszukiwanie lub filtry"
					/>
				</div>
			) : null}
		</div>
	)
}
